import { Accordion } from '@uhg-abyss/web/ui/Accordion';
import { Text } from '@uhg-abyss/web/ui/Text';
import { find } from 'lodash';
import React from 'react';

import { useLagoon } from '../../../../hooks/useLagoon';
import { AreaOfExpertiseDetails } from '../../../../models/ProviderDetails';
import { ConstantsLagoon } from '../../../ConstantsLagoon';
import { CollapseCardHeaderStyle } from '../About.styled';

type Props = {
  areaOfExpertiseDetails?: AreaOfExpertiseDetails[];
};

export const AoeDescriptionContent = ({ areaOfExpertiseDetails }: Props) => {
  const lagoonData = useLagoon('ui-messaging')();
  const aoeDescriptionData = find(lagoonData, {
    key: ConstantsLagoon.UI_MESSAGING.AOE_DESCRIPTION_DRAWER_SUBTITLE,
  });

  return (
    <React.Fragment>
      <Text
        color="#4B4D4F"
        css={{
          'abyss-text-root': { display: 'block' },
        }}
        size={16}
      >
        {aoeDescriptionData?.message}
      </Text>
      <Accordion
        css={{
          ...(CollapseCardHeaderStyle() as any),
          margin: '0 -16px',
          width: 'calc(100% + 32px)',
          marginBottom: '16px',
          '.abyss-accordion-trigger': {
            padding: '16px',
            minHeight: '56px',
            boxSizing: 'border-box',
            backgroundColor: 'transparent',
          },
          '.abyss-accordion-trigger[aria-expanded="true"]': {
            backgroundColor: '#EDF3FB',
          },
          '.abyss-accordion-item[data-state="open"] .abyss-accordion-trigger': {
            backgroundColor: '#EDF3FB',
          },
        }}
        defaultValue={`${areaOfExpertiseDetails?.[0]?.name}-0`}
        isCollapsible
      >
        {areaOfExpertiseDetails &&
          areaOfExpertiseDetails?.map((item, index) => (
            <Accordion.Item
              key={`${item.name}-${index}`}
              value={`${item.name}-${index}`}
            >
              <Accordion.Header>
                {item.name}
              </Accordion.Header>

              <Accordion.Content
                css={{
                  'abyss-accordion-content-container': {
                    borderBottom: '1px solid #CBCCCD',
                  },
                }}
              >
                <div>
                  <Text
                    color="#4B4D4F"
                    css={{ 'abyss-text-root': { lineHeight: '24px' } }}
                    size={16}
                  >
                    {item?.description}
                  </Text>
                </div>
              </Accordion.Content>
            </Accordion.Item>
          ))}
      </Accordion>
    </React.Fragment>
  );
};
